import { DomItem } from "../domItem"
import { SingleCrop } from "./Cropping"
import { SingleDisabledField } from "./Disabled"
import { getCurrentYearStyle, getFieldName } from "./content"
import { TimelineComponentProps } from "./types"

interface Props extends Pick<TimelineComponentProps, "vm" | "onPointerDown"> {
    field: DomItem
    verticalOffset: number
    fieldWidth: number
    style?: any
}

export function SingleField(props: Props) {

    const { vm, onPointerDown, field, fieldWidth, verticalOffset } = props
    let { style } = props

    style = style
        ? { ...style, minWidth: '100%' }
        : { height: field.height + 'px', width: vm.fullWidth + 'px', minWidth: '100%' }

    const fieldName = getFieldName(field, vm.showIds)

    const cropping = vm.allitems.filter(i => i.isCropping() && (i.fieldId == field.fieldId) && (!i.disabled))
    const disabled = vm.disabledYears.filter(i => i.fieldId == field.fieldId)

    const showFieldName = vm.viewConfig.fieldHeight > 0

    return (

        <div
            className={`tl-field ${field.cssClass}`}
            key={field.id}
            onMouseOver={() => field.mouseOver = true}
            onMouseLeave={() => field.mouseOver = false}
            onPointerDown={e => onPointerDown(e, field)}
            style={style}>

            {
                showFieldName &&
                <div className="content" style={{ marginTop: "0", width: fieldWidth ? fieldWidth + "px" : undefined }}>
                    <div className="inner" style={{ textAlign: "left" }}>
                        <span>
                            <span>{fieldName}</span>
                            <span className="a">{field.vm.area} ha</span>
                        </span>
                        <span></span>
                    </div>
                </div>
            }

            <div className="current-year" style={getCurrentYearStyle(vm)}>
            </div>

            {
                cropping.map(c => SingleCrop({ ...props, cropping: c, relativeTop: verticalOffset }))
            }

            {
                disabled.map(year => SingleDisabledField({ ...props, year, relativeTop: verticalOffset }))
            }

        </div>

    )
}
